 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AppHome":"AppHome","App_About~App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~~f1ef34ed":"App_About~App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~~f1ef34ed","App_About~App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~~a9274cdb":"App_About~App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~~a9274cdb","App_About~TestHome":"App_About~TestHome","App_About":"App_About","TestHome":"TestHome","App_Home_Reads~App_Home_Tests~Class_Room":"App_Home_Reads~App_Home_Tests~Class_Room","Class_Room":"Class_Room","App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~App_BookVi~e10ed57e":"App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~App_BookVi~e10ed57e","App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~App_BookVi~24619a54":"App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~App_BookVi~24619a54","App_Account_Home":"App_Account_Home","App_Account_Payment_History":"App_Account_Payment_History","App_Account_Profile":"App_Account_Profile","App_Account_Subscription":"App_Account_Subscription","App_BookViewer":"App_BookViewer","App_Home":"App_Home","App_Institute_Add":"App_Institute_Add","App_Login_Authenticate":"App_Login_Authenticate","App_Login_Enrol":"App_Login_Enrol","App_Notes":"App_Notes","App_Objective_Tests":"App_Objective_Tests","App_Objective_Tests_Attempt":"App_Objective_Tests_Attempt","App_Objective_Tests_Instructions":"App_Objective_Tests_Instructions","App_Objective_Tests_Results":"App_Objective_Tests_Results","App_Plan":"App_Plan","App_Plan_Details":"App_Plan_Details","App_Plan_Purchase":"App_Plan_Purchase","App_Subjective_Tests":"App_Subjective_Tests","App_Subjective_Tests_Correction":"App_Subjective_Tests_Correction","App_Subjective_Tests_Instruction":"App_Subjective_Tests_Instruction","App_Subjective_Tests_Previous_Submission":"App_Subjective_Tests_Previous_Submission","App_Subjective_Tests_Questions":"App_Subjective_Tests_Questions","App_Subjective_Tests_Upload_Answer":"App_Subjective_Tests_Upload_Answer","App_Subjects":"App_Subjects","App_Subjects_Watch":"App_Subjects_Watch","App_eBooks":"App_eBooks","Discover":"Discover","Link_Video":"Link_Video","Publication_Test":"Publication_Test","App_Home_Reads_Notes":"App_Home_Reads_Notes","App_Home_Reads_eBooks":"App_Home_Reads_eBooks","App_Home_Tests_Objective":"App_Home_Tests_Objective","App_Home_Tests_Subjective":"App_Home_Tests_Subjective","App_Home_Video":"App_Home_Video","App_Home_Reads":"App_Home_Reads","App_Home_Tests":"App_Home_Tests","App_Home_Settings":"App_Home_Settings","Link_Institute":"Link_Institute","PublicationHome":"PublicationHome","App_Login_Home":"App_Login_Home","Buttons":"Buttons","ClassHome":"ClassHome","Class_Home":"Class_Home","LinkHome":"LinkHome","Link_Broken":"Link_Broken","Typography":"Typography","FormInputs":"FormInputs"}[chunkId]||chunkId) + "." + {"AppHome":"b443e185","App_About~App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~~f1ef34ed":"8baecc38","App_About~App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~~a9274cdb":"c7b6ddd2","App_About~TestHome":"a280d271","App_About":"bde24c02","TestHome":"5f0ff9bc","chunk-7d672c6c":"e1a9169f","App_Home_Reads~App_Home_Tests~Class_Room":"087ec288","Class_Room":"644187cd","App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~App_BookVi~e10ed57e":"4e816f4e","App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~App_BookVi~24619a54":"f56da9de","App_Account_Home":"ca12dd0c","App_Account_Payment_History":"3b742c40","App_Account_Profile":"56bcc9a7","App_Account_Subscription":"9ec65257","App_BookViewer":"e52250aa","App_Home":"153ce104","App_Institute_Add":"594acda1","App_Login_Authenticate":"dfa1f209","App_Login_Enrol":"0faccf35","App_Notes":"ddc0b044","App_Objective_Tests":"192b7d2b","App_Objective_Tests_Attempt":"ec437430","App_Objective_Tests_Instructions":"660848f4","App_Objective_Tests_Results":"4d117826","App_Plan":"168ff9a6","App_Plan_Details":"56f503ec","App_Plan_Purchase":"4553dd5f","App_Subjective_Tests":"de23b0d9","App_Subjective_Tests_Correction":"a0bea05d","App_Subjective_Tests_Instruction":"d024d9ae","App_Subjective_Tests_Previous_Submission":"ab13be78","App_Subjective_Tests_Questions":"9ee3cbcd","App_Subjective_Tests_Upload_Answer":"08986598","App_Subjects":"9f50df5b","App_Subjects_Watch":"a07d9121","App_eBooks":"9ed3e10a","Discover":"b3d55522","Link_Video":"5b6f8967","Publication_Test":"535f1b3f","App_Home_Reads_Notes":"72c25b44","App_Home_Reads_eBooks":"a2a01550","App_Home_Tests_Objective":"019c314c","App_Home_Tests_Subjective":"b105a36f","App_Home_Video":"587cf6ba","App_Home_Reads":"df4068fd","App_Home_Tests":"995d3bc0","App_Home_Settings":"d601b208","Link_Institute":"f38dc893","PublicationHome":"12c92bca","App_Login_Home":"d69c3aff","Buttons":"3a82a9a5","ClassHome":"ded01dbf","Class_Home":"081e2fdf","LinkHome":"c89c4122","Link_Broken":"94f0d6f2","Typography":"918e8fb8","FormInputs":"6823c6f8","chunk-9758c040":"872bd006"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AppHome":1,"App_About~App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~~f1ef34ed":1,"App_About~App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~~a9274cdb":1,"App_About~TestHome":1,"App_About":1,"TestHome":1,"chunk-7d672c6c":1,"App_Home_Reads~App_Home_Tests~Class_Room":1,"Class_Room":1,"App_Account_Home":1,"App_Account_Payment_History":1,"App_Account_Profile":1,"App_Account_Subscription":1,"App_BookViewer":1,"App_Home":1,"App_Institute_Add":1,"App_Login_Authenticate":1,"App_Login_Enrol":1,"App_Notes":1,"App_Objective_Tests":1,"App_Objective_Tests_Attempt":1,"App_Objective_Tests_Instructions":1,"App_Objective_Tests_Results":1,"App_Plan":1,"App_Plan_Details":1,"App_Plan_Purchase":1,"App_Subjective_Tests":1,"App_Subjective_Tests_Correction":1,"App_Subjective_Tests_Instruction":1,"App_Subjective_Tests_Previous_Submission":1,"App_Subjective_Tests_Questions":1,"App_Subjective_Tests_Upload_Answer":1,"App_Subjects":1,"App_Subjects_Watch":1,"App_eBooks":1,"Discover":1,"Link_Video":1,"Publication_Test":1,"App_Home_Reads_Notes":1,"App_Home_Reads_eBooks":1,"App_Home_Tests_Objective":1,"App_Home_Tests_Subjective":1,"App_Home_Video":1,"App_Home_Reads":1,"App_Home_Tests":1,"App_Home_Settings":1,"Link_Institute":1,"PublicationHome":1,"App_Login_Home":1,"Buttons":1,"FormInputs":1,"chunk-9758c040":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AppHome":"AppHome","App_About~App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~~f1ef34ed":"App_About~App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~~f1ef34ed","App_About~App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~~a9274cdb":"App_About~App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~~a9274cdb","App_About~TestHome":"App_About~TestHome","App_About":"App_About","TestHome":"TestHome","App_Home_Reads~App_Home_Tests~Class_Room":"App_Home_Reads~App_Home_Tests~Class_Room","Class_Room":"Class_Room","App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~App_BookVi~e10ed57e":"App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~App_BookVi~e10ed57e","App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~App_BookVi~24619a54":"App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~App_BookVi~24619a54","App_Account_Home":"App_Account_Home","App_Account_Payment_History":"App_Account_Payment_History","App_Account_Profile":"App_Account_Profile","App_Account_Subscription":"App_Account_Subscription","App_BookViewer":"App_BookViewer","App_Home":"App_Home","App_Institute_Add":"App_Institute_Add","App_Login_Authenticate":"App_Login_Authenticate","App_Login_Enrol":"App_Login_Enrol","App_Notes":"App_Notes","App_Objective_Tests":"App_Objective_Tests","App_Objective_Tests_Attempt":"App_Objective_Tests_Attempt","App_Objective_Tests_Instructions":"App_Objective_Tests_Instructions","App_Objective_Tests_Results":"App_Objective_Tests_Results","App_Plan":"App_Plan","App_Plan_Details":"App_Plan_Details","App_Plan_Purchase":"App_Plan_Purchase","App_Subjective_Tests":"App_Subjective_Tests","App_Subjective_Tests_Correction":"App_Subjective_Tests_Correction","App_Subjective_Tests_Instruction":"App_Subjective_Tests_Instruction","App_Subjective_Tests_Previous_Submission":"App_Subjective_Tests_Previous_Submission","App_Subjective_Tests_Questions":"App_Subjective_Tests_Questions","App_Subjective_Tests_Upload_Answer":"App_Subjective_Tests_Upload_Answer","App_Subjects":"App_Subjects","App_Subjects_Watch":"App_Subjects_Watch","App_eBooks":"App_eBooks","Discover":"Discover","Link_Video":"Link_Video","Publication_Test":"Publication_Test","App_Home_Reads_Notes":"App_Home_Reads_Notes","App_Home_Reads_eBooks":"App_Home_Reads_eBooks","App_Home_Tests_Objective":"App_Home_Tests_Objective","App_Home_Tests_Subjective":"App_Home_Tests_Subjective","App_Home_Video":"App_Home_Video","App_Home_Reads":"App_Home_Reads","App_Home_Tests":"App_Home_Tests","App_Home_Settings":"App_Home_Settings","Link_Institute":"Link_Institute","PublicationHome":"PublicationHome","App_Login_Home":"App_Login_Home","Buttons":"Buttons","ClassHome":"ClassHome","Class_Home":"Class_Home","LinkHome":"LinkHome","Link_Broken":"Link_Broken","Typography":"Typography","FormInputs":"FormInputs"}[chunkId]||chunkId) + "." + {"AppHome":"4b5175c4","App_About~App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~~f1ef34ed":"c46d2635","App_About~App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~~a9274cdb":"cce48b1d","App_About~TestHome":"4f5f18aa","App_About":"4e8b6579","TestHome":"b992015d","chunk-7d672c6c":"93820a10","App_Home_Reads~App_Home_Tests~Class_Room":"a7d9d3bc","Class_Room":"293069ad","App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~App_BookVi~e10ed57e":"31d6cfe0","App_Account_Home~App_Account_Payment_History~App_Account_Profile~App_Account_Subscription~App_BookVi~24619a54":"31d6cfe0","App_Account_Home":"8a08cc05","App_Account_Payment_History":"ceb6b045","App_Account_Profile":"4ddc4a29","App_Account_Subscription":"d0befe2b","App_BookViewer":"1a2ae469","App_Home":"f407a2e0","App_Institute_Add":"1a616899","App_Login_Authenticate":"1257c851","App_Login_Enrol":"1491198c","App_Notes":"5df86cea","App_Objective_Tests":"3318b3dc","App_Objective_Tests_Attempt":"72eb0732","App_Objective_Tests_Instructions":"605a3ddd","App_Objective_Tests_Results":"19fed4ed","App_Plan":"03447099","App_Plan_Details":"6d4510f0","App_Plan_Purchase":"fea76880","App_Subjective_Tests":"08fcd61b","App_Subjective_Tests_Correction":"c961523d","App_Subjective_Tests_Instruction":"ed4e61d0","App_Subjective_Tests_Previous_Submission":"e9109cc3","App_Subjective_Tests_Questions":"1a2ae469","App_Subjective_Tests_Upload_Answer":"91860485","App_Subjects":"5429a895","App_Subjects_Watch":"ac751298","App_eBooks":"b4bac293","Discover":"918c3534","Link_Video":"06682282","Publication_Test":"9c5c493a","App_Home_Reads_Notes":"5d2c13e5","App_Home_Reads_eBooks":"5d2c13e5","App_Home_Tests_Objective":"5d2c13e5","App_Home_Tests_Subjective":"5d2c13e5","App_Home_Video":"42c0e2c0","App_Home_Reads":"1ca15dd1","App_Home_Tests":"62cad958","App_Home_Settings":"d00c4821","Link_Institute":"52e31ee6","PublicationHome":"54eccaec","App_Login_Home":"fd30ed4b","Buttons":"4237418c","ClassHome":"31d6cfe0","Class_Home":"31d6cfe0","LinkHome":"31d6cfe0","Link_Broken":"31d6cfe0","Typography":"31d6cfe0","FormInputs":"75437973","chunk-9758c040":"056bd7e5"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
